// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2M7FO","label":"Section_label__2kksd","contentWrap":"Section_contentWrap__3qlXn","footer":"Section_footer__16J26","footerInner":"Section_footerInner__2-eQJ"};